import InstagramSkin1 from "./skins/instagram-skin-1/instagram-skin-1";
import InstagramSkin2 from "./skins/instagram-skin-2/instagram-skin-2";
import { FC } from "react";
import { InstagramConfig, InstagramData, WidgetProps, WidgetType } from "@commons-monorepo/index";

const Instagram: FC<WidgetProps<InstagramData[], InstagramConfig>> = (props) => {
  return (
    <>
      {props.type === WidgetType.INSTAGRAM_1 && <InstagramSkin1 {...props} />}
      {props.type === WidgetType.INSTAGRAM_2 && <InstagramSkin2 {...props} />}
    </>
  );
};

export default Instagram;
